import React from 'react'
import ReportWrapper from '../ReportWrapper'
import ReportSectionHeading from '../ReportSectionHeading'
import { Stack, Text } from '@mantine/core'
import { useTheme } from '../../../components/ThemeProvider'
import dayjs from 'dayjs'
import TianyanchaRecordCard from '../TianyanchaRecordCard'

interface CertificateItem {
  certNo: string
  endDate: string
  certificateName: string
  id: string
  detail: Array<{ title: string; content: string }>
  startDate: string
}

interface TianyanchaCertificateProps {
  data: any
  title: string
  sectionIndex?: string
}

const getDetailValue = (detail: Array<{ title: string; content: string }> = [], title: string) => {
  return detail.find((item) => item.title === title)?.content || '—'
}

const formatDate = (value?: string) => {
  if (!value) return '—'
  return dayjs(value).isValid() ? dayjs(value).format('YYYY-MM-DD') : value
}

const normalizeItems = (items: CertificateItem[] = []) => {
  return items.map((item) => {
    const status = getDetailValue(item.detail, '证书状态')
    const issueOrg = getDetailValue(item.detail, '发证机关')
    const holder = getDetailValue(item.detail, '持证人')

    return {
      name: item.certificateName || '—',
      number: item.certNo || '—',
      startDate: formatDate(item.startDate),
      endDate: formatDate(item.endDate),
      status,
      issueOrg,
      holder,
    }
  })
}

export default function TianyanchaCertificate({ data, title, sectionIndex }: TianyanchaCertificateProps) {
  let jsonData: any
  try {
    jsonData = JSON.parse(data.tianyancha_certificate ?? '{}')
  } catch (error) {
    jsonData = {}
  }

  const certificates = normalizeItems(jsonData.items)
  const theme = useTheme()

  return (
    <ReportWrapper>
      <ReportSectionHeading title={title} index={sectionIndex} />
      <div className="mt-2">
        <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
          资质证书信息
        </Text>
        <Stack gap="sm" className="mt-3">
          {certificates.length === 0 ? (
            <Text c="dimmed" size="sm" ta="center">
              暂无资质证书信息
            </Text>
          ) : (
            certificates.map((item, index) => {
              const isExpired = item.status.includes('过期')
              return (
                <TianyanchaRecordCard
                  key={`${item.number}-${index}`}
                  number={index + 1}
                  recordType="证书"
                  fields={[
                    { label: '证书名称', value: item.name, span: 2 },
                    { label: '证书编号', value: item.number },
                    { label: '有效期', value: `${item.startDate} 至 ${item.endDate}` },
                    { label: '发证机关', value: item.issueOrg },
                    { label: '证书状态', value: item.status, highlight: isExpired },
                  ]}
                />
              )
            })
          )}
        </Stack>
      </div>
    </ReportWrapper>
  )
}
